function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgDat = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M15.04 4.205c.295 0 .532.09.71.269.18.179.27.415.27.71v8.756c0 .997-.237 1.907-.711 2.726a5.163 5.163 0 01-1.9 1.92c-.794.46-1.684.69-2.67.69-.985 0-1.888-.23-2.707-.69a5.163 5.163 0 01-1.9-1.92c-.461-.82-.692-1.728-.692-2.726 0-.999.211-1.902.634-2.708.435-.819 1.024-1.46 1.766-1.92a4.738 4.738 0 012.515-.691 4.73 4.73 0 013.706 1.747V5.184c0-.295.09-.531.27-.71a.998.998 0 01.71-.27zm-4.3 13.344c.64 0 1.216-.154 1.727-.461a3.35 3.35 0 001.23-1.305 3.855 3.855 0 00.441-1.843c0-.678-.147-1.287-.442-1.824a3.215 3.215 0 00-1.229-1.287 3.195 3.195 0 00-1.728-.48c-.64 0-1.222.16-1.747.48-.517.312-.94.756-1.229 1.287-.294.537-.44 1.145-.44 1.824 0 .678.146 1.292.44 1.842.291.534.715.983 1.23 1.306.524.307 1.107.46 1.747.46z",
    fill: "white"
  }));
});
SvgDat.displayName = "SvgDat";
SvgDat.defaultProps = {
  size: 24,
  color: "#2D9CDB"
};
export default SvgDat;